import * as React from 'react';

function ChangeUserCategoryIcon({ width = 16, height = 16, color = '#545454', ...props }) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 24 24'
			fill='none'
			{...props}
		>
			<path
				d='M11.5 15H7a4 4 0 00-4 4v2m18.378-4.374a2.124 2.124 0 00-3.004-3.004l-4.01 4.012a1.999 1.999 0 00-.506.854l-.837 2.87a.5.5 0 00.62.62l2.87-.837a2 2 0 00.854-.506l4.013-4.01zM14 7a4 4 0 11-8 0 4 4 0 018 0z'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default ChangeUserCategoryIcon;
